import { GetCreditHistoryRes_ReceivableHistoryItem } from "gen/api/billpayment/service_pb"
import { FieldMapping } from "shared-ts/adapters/useQueryAdapter"
import { Money } from "shared-ts/classes/money"
import { BaseReceivable, getReceivableMapping } from "shared-ts/receivables"

export interface ReceivableHistoryItem extends BaseReceivable {
  balanceDelta: Money
  runningBalance: Money
}

export const receivableHistoryMapping: FieldMapping<
  GetCreditHistoryRes_ReceivableHistoryItem,
  ReceivableHistoryItem
> = {
  ...getReceivableMapping(),
  balanceDelta: (res) => Money.fromPB(res.balanceDelta),
  runningBalance: (res) => Money.fromPB(res.runningBalance),
}
